import { textblockTypeInputRule } from '@tiptap/core'
import { Heading } from '@tiptap/extension-heading'

const ALL_LEVELS = [1, 2, 3, 4, 5, 6]

// Maps any level to the nearest allowed one (h1 → h2, h5/h6 → h4 with [2, 3, 4]).
const closestLevel = (level, levels) => Math.min(Math.max(level, Math.min(...levels)), Math.max(...levels))

/**
 * Heading limited to `levels` (configured as [2, 3, 4] in TipTapEditorComponent)
 * so free-form content never competes with the page's own H1.
 *
 * The stock Heading only parses the tags of allowed levels, so any other <hN> in
 * saved content would silently degrade to a paragraph. Here every h1-h6 is parsed
 * and remapped to the nearest allowed level instead, keeping marks and alignment.
 * Same for Markdown shortcuts: "# " and "##### "/"###### " land on the nearest level.
 * Keyboard shortcuts (Mod-Alt-N) are still only registered for the allowed levels.
 */
export const RestrictedHeadingNode = Heading.extend({
  parseHTML() {
    return ALL_LEVELS.map(level => ({
      tag: `h${level}`,
      attrs: { level: closestLevel(level, this.options.levels) },
    }))
  },

  addInputRules() {
    return this.options.levels.map(level => {
      const matching = ALL_LEVELS.filter(l => closestLevel(l, this.options.levels) === level)
      return textblockTypeInputRule({
        find: new RegExp(`^(#{${Math.min(...matching)},${Math.max(...matching)}})\\s$`),
        type: this.type,
        getAttributes: { level },
      })
    })
  },
})

export default RestrictedHeadingNode
